document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function () {
    const zoomActive =
      document.querySelector('.pswp--open') ||
      document.querySelector('[data-zoom-active="true"]');

    if (zoomActive) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
  });

  // Lås op ved ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  });
});
